import { isFunction } from './type-guards';
// timeout function for backwards compatibility
export function timeout(fn) {
    if (isFunction(fn)) {
        // 300 is default value in data-api.js
        setTimeout(fn, 300);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGltZW91dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jZHAvdXRpbHMvdGltZW91dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBRTNDLCtDQUErQztBQUMvQyxNQUFNLFVBQVUsT0FBTyxDQUFDLEVBQVc7SUFDakMsSUFBSSxVQUFVLENBQUMsRUFBRSxDQUFDLEVBQUUsQ0FBQztRQUNuQixzQ0FBc0M7UUFDdEMsVUFBVSxDQUFDLEVBQUUsRUFBRSxHQUFHLENBQUMsQ0FBQztJQUN0QixDQUFDO0FBQ0gsQ0FBQyJ9